var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"goTop",class:{ btnFlag: _vm.btnFlag },on:{"click":function($event){$event.preventDefault();return _vm.goTop($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }